import { algoliaSearch } from '../../../global/algolia/algoliaInstantSearch/instantSearch';
import { configureWidget } from './widgets/configure';
import { initSortByWidget } from './widgets/sortBy';
import { customStatsWidget } from './widgets/customStats';
import { initCurrentRefinements } from './widgets/currentRefinements';
import { initClearRefinements } from './widgets/clearRefinements';
import { initHits } from './widgets/hits';
import { initRangeSlider } from './widgets/rangeSlider';
import { initRangeInput } from './widgets/rangeInput';
import { initPagination } from './widgets/pagination';
import initFacets from './widgets/facets';

// TODO: to think about spliting initialization of widget from widgets' logic
const initWidgets = () => {
	const hitsWidget = initHits();
	const paginationWidget = initPagination();
	const rangeSliderWidget = initRangeSlider();
	const currentRefinementsWidget = initCurrentRefinements();
	const clearRefinementsWidget = initClearRefinements();
	const sortByWidget = initSortByWidget();
	const rangeInput = initRangeInput(algoliaSearch);

	algoliaSearch.addWidgets([
		configureWidget,
		sortByWidget,
		customStatsWidget,
		currentRefinementsWidget,
		clearRefinementsWidget,
		hitsWidget,
		paginationWidget,
		rangeSliderWidget,
		rangeInput,
	]);
	initFacets(algoliaSearch);
};

// Algolia initialization for search result page
algoliaSearch.start();

export default initWidgets;
